import earlyDecisionContract from './early-decision-contract'
import feeWaiver from './fee-waiver'
import ferpa from './ferpa'
import highSchoolEmail from './highschool-email'
import outcomes from './outcomes'
import personalDetailActions from './personal-details'
import potentialHighSchool from './potential-highschool'

export default {
  ...personalDetailActions,
  ...highSchoolEmail,
  ...ferpa,
  ...potentialHighSchool,
  ...outcomes,
  ...earlyDecisionContract,
  ...feeWaiver,
}
